import { Box, Button, Stack, Tooltip } from '@mui/material'
import { useLocation, useNavigate } from 'react-router-dom'
import { Hicon } from './Hicon'
import { isInsightsPath } from './DomainNav'
import { rotaSemInsights } from './panelInsightsDomains'
import { usePanelInsights } from '../state/PanelInsightsContext'

const BTN_SX = {
  height: 36,
  minWidth: { xs: 0, sm: 124 },
  px: { xs: 1.25, sm: 1.75 },
  borderRadius: '10px',
  textTransform: 'none',
  fontWeight: 700,
  fontFamily: '"Outfit", sans-serif',
  fontSize: '0.85rem',
  letterSpacing: 0.02,
} as const

/**
 * Business · Insights — fica no AppBar (visível mesmo sem FONTE DE DADOS).
 *
 * «Business» leva ao operacional. «Insights» abre a gaveta com a leitura e as
 * sugestões da IA sobre o painel aberto no momento (decisão da Mariana,
 * 23/09/2026: o botão deixou de trocar de pista e passou a ser útil em qualquer
 * tela, exceto Buy Box, Consulta Marcas INPI e Usuários).
 */
export function LaneSwitch() {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const { aberto, alternar, fechar } = usePanelInsights()
  const semInsights = rotaSemInsights(pathname)
  const businessSelected = !aberto

  return (
    <Stack direction="row" spacing={1} alignItems="center" sx={{ flexShrink: 0 }}>
      <Tooltip title="Visão operacional — vendas, pedidos, margens">
        <Button
          variant={businessSelected ? 'contained' : 'outlined'}
          color="primary"
          onClick={() => {
            if (aberto) fechar()
            if (isInsightsPath(pathname)) navigate('/')
          }}
          startIcon={<Hicon name="bag" sx={{ fontSize: '1.05rem' }} />}
          sx={{
            ...BTN_SX,
            boxShadow: businessSelected ? undefined : 'none',
            borderWidth: businessSelected ? undefined : 1.5,
          }}
        >
          Business
        </Button>
      </Tooltip>
      <Tooltip
        title={
          semInsights
            ? 'Sem insights da IA neste painel'
            : aberto
              ? 'Fechar insights da IA'
              : 'Insights e sugestões da IA sobre o painel aberto'
        }
      >
        {/* span: o Tooltip precisa de um filho que receba eventos mesmo com o botão desabilitado */}
        <Box component="span" sx={{ display: 'inline-flex' }}>
          <Button
            variant={aberto ? 'contained' : 'outlined'}
            color="primary"
            disabled={semInsights}
            aria-pressed={aberto}
            aria-label="Insights da IA do painel aberto"
            onClick={alternar}
            startIcon={<Hicon name="graph" sx={{ fontSize: '1.05rem' }} />}
            sx={{
              ...BTN_SX,
              boxShadow: aberto ? undefined : 'none',
              borderWidth: aberto ? undefined : 1.5,
            }}
          >
            Insights
          </Button>
        </Box>
      </Tooltip>
    </Stack>
  )
}
